// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { LoginResponseFragmentDoc } from './fragments/loginResponse.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LoginWithGoogleDocument = gql`
    mutation loginWithGoogle($credentials: CustomerRegistrationByGoogleInput!, $locale: Locale!, $isConsultant: Boolean!) {
  loginWithGoogle(credentials: $credentials) {
    ...loginResponse
  }
}
    ${LoginResponseFragmentDoc}`;

export function useLoginWithGoogleMutation() {
  return Urql.useMutation<SchemaTypes.LoginWithGoogleMutation, SchemaTypes.LoginWithGoogleMutationVariables>(LoginWithGoogleDocument);
};